import { render } from "./CareAssignment.vue?vue&type=template&id=0b562dd0&scoped=true&ts=true"
import script from "./CareAssignment.vue?vue&type=script&lang=ts"
export * from "./CareAssignment.vue?vue&type=script&lang=ts"

import "./CareAssignment.vue?vue&type=style&index=0&id=0b562dd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b562dd0"]])

export default __exports__